import type { ChallengeInfo } from "@expert/sales-tools";
import type { JSX } from "react";

import { Modal } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";

import { useAnalytics } from "@/analytics";
import classes from "@/sales-tools/micro-learning/components/MicroLearning.module.css";

import { AnnouncementStartCoverQuiz } from "./AnnouncementStartCoverQuiz";
import { AnnouncementStartGeneric } from "./AnnouncementStartGeneric";

export function AnnouncementStartFactory({ challenge }: { challenge: ChallengeInfo }): JSX.Element {
    const [opened, { close }] = useDisclosure(true);
    const { dispatcher } = useAnalytics();
    const sendAckEvent = () => {
        void dispatcher.dispatchBusinessEvent("ChallengeAcknowledgedStart", {
            challengeParticipantId: challenge.announcement.challengeParticipantId,
            challengeId: challenge.challengeId,
        });
    };

    const closeModal = () => {
        if (challenge.challengeType !== "quiz") {
            sendAckEvent();
        }
        close();
    };

    const handleContinueClick = () => {
        sendAckEvent();
        close();
    };

    const { challengeType } = challenge;

    const renderContent = () => {
        switch (challengeType) {
            case "quiz":
                return <AnnouncementStartCoverQuiz challenge={challenge} onContinueClick={handleContinueClick} />;
            default:
                return <AnnouncementStartGeneric challenge={challenge} onContinueClick={handleContinueClick} />;
        }
    };

    return (
        <Modal
            zIndex="var(--mantine-priority-highest)"
            centered
            opened={opened}
            onClose={closeModal}
            withCloseButton={false}
            padding={0}
            overlayProps={{
                backgroundOpacity: 0.4,
            }}
            classNames={{ content: classes.content }}
        >
            {renderContent()}
        </Modal>
    );
}
